import {FC} from "react";
import {LearnCategory} from "../../../lib/src/api/repositories/learn-repository";
import {useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const UnpinLearnCategoryModal: FC<{ category: LearnCategory, reload: () => void }> = (props) => {
  const {learn} = useApiCall(config)

  const save = async () => {
    await learn.editCategory(props.category.id, props.category.name, props.category.parent_category_id, false)
    props.reload()
  }

  return <>
    <div>
      De categorie <span className={'font-bold'}>{props.category.name}</span> los maken?
    </div>
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </>
}